import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col, Badge, Alert } from 'react-bootstrap';
import './MessageTemplates.css';

const defaultTemplates = [
    {
        id: 'saudade',
        name: '💜 Sentimos sua falta',
        category: 'geral',
        message: 'Olá {{nome}}, tudo bem? Sentimos sua falta! Já faz {{dias}} dias desde sua última compra. Passa lá na loja pra ver as novidades: {{link}}'
    },
    {
        id: 'produto_favorito',
        name: '⭐ Produto Favorito',
        category: 'personalizado',
        message: 'Oi {{nome}}! Lembrei de você porque chegou mais {{produto_favorito}} na loja! Como você gostou tanto, quis te avisar em primeira mão. Confere aqui: {{link}}'
    },
    {
        id: 'desconto_vip',
        name: '🎁 Desconto VIP',
        category: 'vip',
        message: 'Ei {{nome}}! Você é cliente especial e preparamos uma surpresa: cupom de 10% OFF exclusivo pra você! Use o código VIP10 no site: {{link}}'
    },
    {
        id: 'importados',
        name: '🌍 Novidades Importadas',
        category: 'importados',
        message: 'Olá {{nome}}! Chegaram novos produtos importados que você vai amar! Como você gosta de {{produto_favorito}}, separei algumas dicas especiais. Veja aqui: {{link}}'
    },
    {
        id: 'urgente',
        name: '🔥 Urgente - Última chance',
        category: 'urgente',
        message: '{{nome}}, última chance! Aquele produto que você comprou está quase esgotando. Garanta o seu antes que acabe: {{link}}'
    },
    {
        id: 'reativacao',
        name: '🎯 Reativação Simples',
        category: 'geral',
        message: 'Oi {{nome}}! Quanto tempo! Passa lá no site pra ver as novidades que chegaram. Tenho certeza que vai encontrar algo que goste: {{link}}'
    },
    {
        id: 'recompra',
        name: '🔄 Hora de Repor',
        category: 'compras',
        message: 'Oi {{nome}}! Já faz {{dias}} dias que você comprou {{produto_favorito}}. Talvez já esteja na hora de uma reposição, né? 😊 Aproveite que temos novidades: {{link}}'
    },
    {
        id: 'agradecimento_fidelidade',
        name: '🏆 Obrigado pela Fidelidade',
        category: 'vip',
        message: '{{nome}}, quero te agradecer por ser nosso cliente! Você já investiu {{total_gasto}} com a gente e isso é muito especial. 💛 Preparamos condições exclusivas pra você: {{link}}'
    },
    {
        id: 'colecao_completa',
        name: '🧩 Complete sua Coleção',
        category: 'personalizado',
        message: 'Oi {{nome}}! Vi que você gosta de {{produto_favorito}}. Chegaram peças novas que combinam perfeitamente! Vem completar sua coleção: {{link}}'
    },
    {
        id: 'novidades_semana',
        name: '📦 Novidades da Semana',
        category: 'geral',
        message: '{{nome}}, tudo bem? Chegaram produtos novos essa semana e lembrei de você! Sua última visita foi em {{ultima_compra}}. Vem ver o que tem de novo: {{link}}'
    },
    {
        id: 'cliente_sumido',
        name: '👀 Cadê Você?',
        category: 'personalizado',
        message: 'Oi {{nome}}, sumiu! 😢 Já faz {{dias}} dias sem te ver por aqui. Você que tanto gostou de {{produto_favorito}}... temos novidades incríveis te esperando! Passa lá: {{link}}'
    },
    {
        id: 'frete_gratis',
        name: '🚚 Frete Grátis',
        category: 'vip',
        message: '{{nome}}, boa notícia! 🎉 Conseguimos FRETE GRÁTIS exclusivo pra você! Como cliente especial, aproveite essa condição especial e confira as novidades: {{link}}'
    },
    {
        id: 'comprou_junto',
        name: '🛍️ Baseado no que Comprou',
        category: 'compras',
        message: 'Oi {{nome}}! Clientes que compraram {{produto_favorito}} também adoraram os lançamentos que acabaram de chegar. Dá uma olhada, acho que você vai gostar: {{link}}'
    },
    {
        id: 'volta_especial',
        name: '💎 Volta Especial',
        category: 'compras',
        message: '{{nome}}, preparamos algo especial pra sua volta! 🎁 Como você já gastou {{total_gasto}} conosco, temos uma surpresa exclusiva te esperando. Acesse e descubra: {{link}}'
    }
];

const MessageTemplates = ({ show, onHide, cliente, onSendMessage }) => {
    const [templates, setTemplates] = useState(defaultTemplates);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [customMessage, setCustomMessage] = useState('');
    const [preview, setPreview] = useState('');
    const [filterCategory, setFilterCategory] = useState('all');

    // Processar variáveis do template
    const processTemplate = (template, client) => {
        if (!template || !client) return '';

        let message = template;

        // Variáveis disponíveis
        const firstName = (client.contato_nome || '').split(' ')[0] || 'cliente';
        const dias = client.dias_sem_comprar || 0;
        const produtoFavorito = Array.isArray(client.produtos_favoritos) && client.produtos_favoritos.length > 0
            ? client.produtos_favoritos[0]?.descricao || 'seu produto favorito'
            : 'seu produto favorito';

        // Total gasto formatado
        const totalGasto = client.total_gasto
            ? `R$ ${Number(client.total_gasto).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
            : 'bastante';

        // Data da última compra formatada
        const ultimaCompra = client.ultima_compra
            ? new Date(client.ultima_compra).toLocaleDateString('pt-BR')
            : 'há algum tempo';

        // Todos os produtos favoritos (top 3)
        const todosProdutos = Array.isArray(client.produtos_favoritos) && client.produtos_favoritos.length > 0
            ? client.produtos_favoritos.map(p => p.descricao?.substring(0, 30)).filter(Boolean).join(', ')
            : 'seus produtos favoritos';

        // Quantidade de compras
        const qtdCompras = client.quantidade_compras || client.total_compras || '';

        // Gerar link rastreável
        const clienteId = client.contato_id || client.id || 'unknown';
        const params = new URLSearchParams({
            utm_source: 'whatsapp',
            utm_medium: 'recuperacao',
            utm_campaign: `winback_${clienteId}`,
            utm_content: 'template',
            utm_term: `${dias}dias`
        });
        const link = `https://www.lojagringao.com.br/?${params.toString()}`;

        // Substituir variáveis
        message = message.replace(/\{\{nome\}\}/gi, firstName);
        message = message.replace(/\{\{dias\}\}/gi, String(dias));
        message = message.replace(/\{\{produto_favorito\}\}/gi, produtoFavorito.substring(0, 40));
        message = message.replace(/\{\{total_gasto\}\}/gi, totalGasto);
        message = message.replace(/\{\{ultima_compra\}\}/gi, ultimaCompra);
        message = message.replace(/\{\{todos_produtos\}\}/gi, todosProdutos);
        message = message.replace(/\{\{quantidade_compras\}\}/gi, String(qtdCompras));
        message = message.replace(/\{\{link\}\}/gi, link);

        return message;
    };

    useEffect(() => {
        if (selectedTemplate && cliente) {
            const processed = processTemplate(selectedTemplate.message, cliente);
            setPreview(processed);
            setCustomMessage(processed);
        }
    }, [selectedTemplate, cliente]);

    const handleSelectTemplate = (template) => {
        setSelectedTemplate(template);
    };

    const handleSend = () => {
        if (!customMessage || !cliente) return;

        const phone = (cliente.celular || cliente.telefone || '').replace(/\D/g, '');
        if (!phone) {
            alert('Cliente não possui telefone cadastrado.');
            return;
        }

        const url = `https://wa.me/55${phone}?text=${encodeURIComponent(customMessage)}`;
        window.open(url, '_blank');

        if (onSendMessage) {
            onSendMessage(cliente, customMessage, selectedTemplate?.id || 'custom');
        }

        onHide();
    };

    const categories = [
        { id: 'all', label: 'Todos', emoji: '📋' },
        { id: 'geral', label: 'Geral', emoji: '💬' },
        { id: 'personalizado', label: 'Personalizado', emoji: '⭐' },
        { id: 'compras', label: 'Compras', emoji: '🛍️' },
        { id: 'vip', label: 'VIP', emoji: '👑' },
        { id: 'importados', label: 'Importados', emoji: '🌍' },
        { id: 'urgente', label: 'Urgente', emoji: '🔥' }
    ];

    const filteredTemplates = filterCategory === 'all'
        ? templates
        : templates.filter(t => t.category === filterCategory);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered className="templates-modal">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title>
                    <span className="me-2">📝</span>
                    Templates de Mensagem
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {cliente && (
                    <Alert variant="info" className="mb-4">
                        <div className="d-flex align-items-center">
                            <span className="me-2">👤</span>
                            <div>
                                <strong>{cliente.contato_nome}</strong>
                                <span className="text-muted ms-2">• {cliente.dias_sem_comprar} dias inativo</span>
                                {cliente.celular && <span className="text-muted ms-2">• 📱 {cliente.celular}</span>}
                            </div>
                        </div>
                    </Alert>
                )}

                <Row>
                    {/* Lista de Templates */}
                    <Col md={5}>
                        <div className="mb-3">
                            <Form.Label className="fw-bold">Categoria</Form.Label>
                            <div className="d-flex flex-wrap gap-1">
                                {categories.map(cat => (
                                    <Button
                                        key={cat.id}
                                        variant={filterCategory === cat.id ? 'primary' : 'outline-secondary'}
                                        size="sm"
                                        onClick={() => setFilterCategory(cat.id)}
                                    >
                                        {cat.emoji} {cat.label}
                                    </Button>
                                ))}
                            </div>
                        </div>

                        <div className="templates-list">
                            {filteredTemplates.map(template => (
                                <div
                                    key={template.id}
                                    className={`template-item ${selectedTemplate?.id === template.id ? 'selected' : ''}`}
                                    onClick={() => handleSelectTemplate(template)}
                                >
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="template-name">{template.name}</div>
                                        <Badge bg="secondary" className="template-category">
                                            {template.category}
                                        </Badge>
                                    </div>
                                    <div className="template-preview">
                                        {template.message.substring(0, 80)}...
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>

                    {/* Preview e Edição */}
                    <Col md={7}>
                        <Card className="preview-card h-100">
                            <Card.Header className="bg-white border-bottom">
                                <h6 className="mb-0">
                                    {selectedTemplate ? '✏️ Editar Mensagem' : '👈 Selecione um template'}
                                </h6>
                            </Card.Header>
                            <Card.Body>
                                {selectedTemplate ? (
                                    <>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-bold">Mensagem</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={6}
                                                value={customMessage}
                                                onChange={(e) => setCustomMessage(e.target.value)}
                                                className="message-textarea"
                                            />
                                            <Form.Text className="text-muted">
                                                Variáveis: {'{{nome}}'}, {'{{dias}}'}, {'{{produto_favorito}}'}, {'{{total_gasto}}'}, {'{{ultima_compra}}'}, {'{{todos_produtos}}'}, {'{{link}}'}
                                            </Form.Text>
                                        </Form.Group>

                                        <div className="phone-preview">
                                            <div className="phone-header">
                                                <div className="d-flex align-items-center">
                                                    <div className="phone-avatar">
                                                        {(cliente?.contato_nome || 'C')[0]}
                                                    </div>
                                                    <div>
                                                        <div className="phone-name">{cliente?.contato_nome || 'Cliente'}</div>
                                                        <div className="phone-status">online</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="phone-body">
                                                <div className="message-bubble">
                                                    {customMessage || 'Sua mensagem aparecerá aqui...'}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-center py-5 text-muted">
                                        <div className="fs-1 mb-3">📱</div>
                                        <p>Selecione um template ao lado para começar</p>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button
                    variant="success"
                    onClick={handleSend}
                    disabled={!customMessage || !cliente}
                >
                    <span className="me-2">📲</span>
                    Enviar WhatsApp
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MessageTemplates;
